import {
    Component,
    Input,
    Output,
    EventEmitter,
    ViewChild,
    ElementRef,
    Renderer2
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import {SlickGridComponent} from 'app/slick-grid/slick-grid.component';
import {BufferGraphService} from 'app/buffer-graph/services/buffer-graph.service';
import {ISlickGridColumn} from 'app/slick-grid/interfaces/slick-grid-column';
import {EventArgs} from 'app/slick-grid/models/event-args';
import {TabComponentBase} from 'app/buffer-graph/models/tab-component-base';
import {ItemAction} from 'app/buffer-graph/models/item-actions/item-action';
import {FreshItemActionHeader} from 'app/buffer-graph/models/item-actions/fresh-item-action-header';
import {FreshItemActionLine} from 'app/buffer-graph/models/item-actions/fresh-item-action-line';
import {ResizeDirection} from 'app/resize-glyph/resize-glyph.component';
import {Size} from 'app/shared/models/size';
import {ColumnSettingsBase} from "../../../slick-grid/models/column-settings-base";
import {BufferGraphDataExchangeService} from "../../services/buffer-graph-data-exchange.service";
import * as moment from "moment";
import {ExcelWorkService} from "../../../services/excel-work.service";
import {ExportExcelColumn} from "../../../shared/models/export-excel-column";
import {ModuleTableName} from "../../../shared/models/module-table-name";

type Action = ItemAction | FreshItemActionHeader;

@Component({
    selector: 'item-actions',
    templateUrl: './item-actions.component.html',
    styleUrls: ['../../../slick-grid/stocks-grid-style.css', '../../styles/tabs-styles.css', './item-actions.component.css']
})
export class ItemActionsComponent extends TabComponentBase<Action, { columns: ExportExcelColumn[], mainRows: any[] }> /*implements OnChanges*/
    /*, AfterViewChecked*/{
    constructor(
        graphService: BufferGraphService,
        exchangeService: BufferGraphDataExchangeService,
        excelService: ExcelWorkService,
        translateService: TranslateService,
        renderer: Renderer2,
        elementRef: ElementRef
    ){
        super(graphService, exchangeService, excelService, translateService, renderer, elementRef);

        this.showCurrentActions = new EventEmitter<void>();
        this.showAllActions = new EventEmitter<void>();

        this.dataView = new Slick.Data.DataView<Action>();
        this.dataView.onRowsChanged.subscribe(() => this.setMainGridSellStyles());

        this.options = {
            syncColumnCellResize: true,
            multiColumnSort: true,
            editable: false,
            enableAsyncPostRender: true,
            boundary: 'body'
        };

        this.lineDataView = new Slick.Data.DataView<FreshItemActionLine>();
        this.lineOptions = {
            syncColumnCellResize: true,
            multiColumnSort: true,
            editable: false,
            enableAsyncPostRender: true,
            boundary: 'body'
        };
        this.generateColumns = true;
        this.translateService.get('Actions').subscribe(t => this.mainRowsSheetName = t);
    }

    @Input()
    public isActive: boolean;

    @Input()
    private allShown: boolean;

    private data: Action[];

    @Input()
    private set actions(actions: Action[]){

        this.data = actions;

        this.dataView.setItems(actions);
        this.selectedFreshHeader = null;
        this.lineDataView.setItems([]);
    }

    // @Input()
    // protected sku: string;
    //
    // @Input()
    // protected warehouseCode: string;

    public isFresh: boolean;

    @Input()
    private set fresh(value: boolean){
        this.heightCoeff = value ? {gr: 50, fgr: 50} : {gr: 100, fgr: 0};
        if (this.isFresh === value && this.isFresh != null)
            return;

        this.isFresh = value;
    }

    private get fresh(): boolean{
        return this.isFresh
    }

    @Input()
    public canSend: boolean;

    @Input()
    protected columnLineSettings: ColumnSettingsBase[];

    @Output()
    private readonly showCurrentActions: EventEmitter<void>;

    @Output()
    private readonly showAllActions: EventEmitter<void>;

    public get verticalDirection(): ResizeDirection{
        return ResizeDirection.Vertical;
    }

    public lineColumns: ISlickGridColumn<FreshItemActionLine>[];

    private selectedFreshHeader: FreshItemActionHeader;

    public freshTemplateRows: string;

    ngOnInit(){
        super.ngOnInit();
        this.gridPropsName = new ModuleTableName('Stocks', 'ActionHistory', this.fresh ? 2 : 1);
        this.gridPropsNameLine = new ModuleTableName('Stocks', 'ActionHistoryLine', this.fresh ? 2 : 1);
    }

    //# use default function for export data
    protected getExportData = this.getExportDataByDefault;

    //# update data for line table
    public onMainGridActiveCellChanged = (args: EventArgs<Slick.OnActiveCellChangedEventArgs<any>>): void =>{
        let action: FreshItemActionHeader;
        if (!this.isFresh || (action = this.dataView.getItem(args.data.row) as FreshItemActionHeader) === this.selectedFreshHeader)
            return;

        this.lineDataView.setItems(action.lines);
        this.gridLineRef.setColumns(this.lineColumns);
        this.gridLineRef.invalidate();
        this.gridLineRef.render();
        this.selectedFreshHeader = action;
    }

    //# show all data (not use now)
    /*public onShowCurrentClick = (): void =>{
        if (!this.allShown)
            return;

        this.showCurrentActions.emit();
    }

    //# show all data (not use now)
    private onShowAllClick = (): void =>{
        if (this.allShown)
            return;

        this.showAllActions.emit();
    }*/


    //# download excel
    public onDownloadClick = (): void =>{
        // if (this.isFresh)
        //     return;
        const fileName = `${this.mainRowsSheetName}_SKU_${this.tab.itemInfo.sku}_Wrh_${this.tab.itemInfo.warehouseCode}.xlsx`;
        this.download(data => this.excelService.downloadReport(
            data.columns,
            data.mainRows,
            [],
            [],
            this.translateService.currentLang,
            this.mainRowsSheetName,
            'descCode',
            [this.gridPropsName],
            0,
            this.mainRowsSheetName,
            []
        )
            .map(file =>{
                return {fileContent: file, fileName};
            }));
    }

    //# send excel to email
    public onSendClick = (): void =>{
        // if (this.isFresh)
        //     return;
        this.sendToEmail(data => this.excelService.sendReport(
            this.tab.itemInfo.sku,
            this.tab.itemInfo.warehouseCode,
            data.columns,
            data.mainRows,
            [],
            [],
            this.translateService.currentLang,
            this.mainRowsSheetName,
            'descCode',
            [this.gridPropsName],
            0,
            this.mainRowsSheetName,
            [],
            this.mainRowsSheetName
        ));
    }


}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/components/item-actions.component/item-actions.component.ts